<template>
  <b-card class="m-lg-5 m-1">
    <b-card-text>
      <b-row>
        <b-col
          cols="12"
          align="center"
        >
          <b-avatar size="80">
            <b-img
              :src="appLogoPath"
              thumbnail
              fluid
            />
          </b-avatar>
        </b-col>
        <b-col
          cols="12"
          align="center"
        >
          <h2>{{ appTitle }}</h2>
        </b-col>
      </b-row>

      <b-card-text align="center">
        <!-- Navegador embutido do WhatsApp/Instagram: não instala em nenhum SO -->
        <div v-if="browserUtil.isInAppBrowser()">
          <p>
            Você abriu esta página pelo navegador de dentro de outro aplicativo,
            que não permite instalar o {{ appTitle }}.
          </p>
          <p>
            Toque nos <b>três pontinhos</b> (ou no botão de compartilhar) e
            escolha <b>Abrir no {{ browserUtil.isIosMobile() ? 'Safari' : 'Chrome' }}</b>.
            Depois é só voltar aqui e tocar em Instalar.
          </p>
        </div>

        <!-- iPhone/iPad: a Apple só permite instalação manual pelo Safari -->
        <div v-else-if="browserUtil.isIosMobile()">
          <p>
            Para instalar no iPhone, abra esta página no <b>Safari</b>, toque no
            botão de compartilhar e, na sequência, em "Adicionar à Tela de
            Início".
          </p>
          <p>
            Você também pode continuar usando normalmente pelo navegador.
          </p>
        </div>

        <!-- Android/desktop com prompt nativo disponível -->
        <div v-else-if="pwa.disponivel">
          <p>
            Para instalar o aplicativo clique no botão
            <b>INSTALAR ESTE APP</b> e, na sequência, em Instalar.
          </p>
        </div>

        <!-- Android/desktop sem prompt: o navegador ainda não liberou -->
        <div v-else>
          <p>
            Seu navegador ainda não liberou a instalação automática. Abra o menu
            do navegador (três pontinhos) e escolha
            <b>Instalar aplicativo</b> ou <b>Adicionar à tela inicial</b>.
          </p>
          <p>
            Você também pode continuar usando normalmente pelo navegador.
          </p>
        </div>
      </b-card-text>

      <b-card-text align="center">
        <b-button
          v-if="pwa.disponivel"
          class="mt-6"
          variant="primary"
          size="lg"
          :disabled="installing"
          @click="install"
        >
          <b-spinner
            v-if="installing"
            small
          />
          <span v-else>Instalar Este App</span>
        </b-button>
        <b-button
          class="mt-2"
          variant="outline-secondary"
          block
          @click="$router.push('/login')"
        >
          Voltar para o Login
        </b-button>
      </b-card-text>
    </b-card-text>
  </b-card>
</template>

<script>
import { BAvatar, BSpinner } from 'bootstrap-vue'
import browserUtil from '../libs/browser-utils'
import pwa from '../libs/pwa-install'

export default {
  name: 'Install',
  components: {
    BAvatar,
    BSpinner,
  },
  data: () => ({
    installing: false,
    browserUtil,
    pwa,
  }),
  computed: {
    appTitle() {
      return process.env.VUE_APP_TITLE
    },
    appLogoPath() {
      return `/img/icons/${process.env.VUE_APP_CODE}/mstile-150x150.png`
    },
  },
  created() {
    if (pwa.instalado) {
      this.$router.push('/login')
    }
  },
  methods: {
    async install() {
      this.installing = true
      try {
        const aceitou = await pwa.instalar()
        if (aceitou) {
          window.location.href = '/'
        }
      } finally {
        this.installing = false
      }
    },
  },
}
</script>
